import { Component } from '@angular/core';
import { TranslocoService } from '@ngneat/transloco';
import { ExposedReadUserDetailsRes } from 'app/interfaces/responses/Exposed/exposedReadUserDetailsRes';
import { LsrauthService } from 'app/services/api/lsrauth/lsrauth.service';

@Component({
    selector: 'app-settings-users-user-roles',
    templateUrl: './settings-users-user-roles.component.html',
    styleUrls: ['./settings-users-user-roles.component.scss'],
})
export class SettingsUsersUserRolesComponent {
    user: ExposedReadUserDetailsRes = null;
    checked = true;

    constructor(
        private lsrauthService: LsrauthService,
        private service: TranslocoService
    ) {
        this.lsrauthService.userDetails.subscribe((userDetails) => (this.user = userDetails));
    }
}
